export default "/_next/static/chunks/fonts/TheinhardtLightItalic-613e8595057cdd78754a25fcca323ffe.woff2";